import { TrackingClient } from '@sparefoot/tracking-client';
import PropTypes from 'prop-types';

export const trackCTAClick = (click_id, click_name, click_text, click_url) => {
	let trackingProps = { click_id, click_name, click_text };

	if (click_url) {
		trackingProps.click_url = click_url;
	}
	if (typeof window !== 'undefined') {
		TrackingClient.trackCTAClick(trackingProps);
	}
};

trackCTAClick.PropTypes = {
	click_id: PropTypes.string,
	click_name: PropTypes.string,
	click_text: PropTypes.string,
	click_url: PropTypes.string,
};

export const trackContactLinkClick = (
	click_id,
	click_name,
	click_text,
	contact_type
) => {
	let trackingProps = {
		click_id,
		click_name,
		click_text,
		contact_type,
	};

	if (typeof window !== 'undefined') {
		TrackingClient.trackContactLinkClicked(trackingProps);
	}
};

trackContactLinkClick.PropTypes = {
	click_id: PropTypes.string,
	click_name: PropTypes.string,
	click_text: PropTypes.string,
	contact_type: PropTypes.string,
};

export const trackOutboundLinkClick = (
	click_id,
	click_name,
	click_text,
	click_url
) => {
	let trackingProps = {
		click_id,
		click_name,
		click_text,
		click_url,
	};

	if (typeof window !== 'undefined') {
		TrackingClient.trackOutboundLinkClicked(trackingProps);
	}
};

trackOutboundLinkClick.PropTypes = {
	click_id: PropTypes.string,
	click_name: PropTypes.string,
	click_text: PropTypes.string,
	click_url: PropTypes.string,
};
